import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <CardsSection />
        <AboutSection />
        <IndexSection />
        <CarouselSection />
        <FeaturesSection />
        <ContactSection />
        <AppSection />
        <TopicsSection />
        <CommentsSection />
        <FAQSection />
        <MediaSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}